import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { BaseText, SkeletonLoader } from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  leftText?: string;
  rightText?: string;
  isLoading?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ChartFooterV2',
  props: {
    leftText: null,
    rightText: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  leftText?: string;
  rightText?: string;
  isLoading?: boolean;
}



const computedLeftText = computed(() => {
  return props.leftText || '-';
});

const computedRightText = computed(() => {
  return props.rightText || '-';
});

return { __sfc: true,props, computedLeftText, computedRightText, BaseText, SkeletonLoader, NebraskaColors }
}

})